<script setup lang="ts">
import { cn } from '@/lib/utils';
import { type HTMLAttributes } from 'vue';

const props = defineProps<{ class?: HTMLAttributes['class'] }>();

const isLoading = ref(true);

onMounted(() => {
  isLoading.value = false;
});
</script>

<template>
  <div v-if="isLoading" :class="cn('pb-4 pt-0', props.class)">
    <slot />
  </div>
  <AccordionContent v-else :class="cn('pb-4 pt-0', props.class)">
    <slot />
  </AccordionContent>
</template>
